{
  "cms.catalogRow.actions.menu": "Toiminnot",
  "cms.catalogRow.action.publish": "Julkaise",
  "cms.catalogRow.action.unpublish": "Poista julkaisusta",
  "cms.catalogRow.publishError": "Julkaisu epäonnistui. Yritä uudelleen.",
  "cms.catalogRow.unpublishError": "Julkaisusta poisto epäonnistui. Yritä uudelleen.",
  "cms.catalog.action.createMenu": "Uusi",
  "cms.catalog.action.createOption.articleTeaser": "Etusivun kortti tai nappi",
  "cms.catalog.action.createOption.benefit": "Etu tai alennus",
  "cms.catalog.action.createOption.videoListing": "Lakiruutu-video",
  "cms.catalog.badge.orphaned": "Ei linkitetty",
  "cms.catalog.unit.benefitDefaultCategory": "Muut edut",
  "cms.catalog.unit.group.benefits": "Edut ja alennukset",
  "cms.catalog.unit.group.buttons": "Etusivun napit",
  "cms.catalog.unit.group.cards": "Etusivun kortit",
  "cms.catalog.unit.group.videos": "Lakiruutu-videot",
  "cms.catalog.empty": "Ei sisältöä vielä.",
  "cms.catalog.errorState": "Sisältöluettelon lataus epäonnistui.",
  "cms.catalog.group.draft": "Luonnokset",
  "cms.catalog.group.orphanedHomeCards": "Etusivun kortit ilman sivua",
  "cms.catalog.group.published": "Julkaistut",
  "cms.catalog.loading": "Ladataan sisältöä…",
  "cms.catalog.title": "Sisällönhallinta",
  "cms.catalog.badge.unpublishedContentChanges": "Julkaisemattomia sisältömuutoksia",
  "cms.fixedEntry.lakikaveriInfo": "Tutustu Lakikaveriin",
  "cms.fixedEntry.oikeusturvavakuutus": "Oikeusturvavakuutus",
  "cms.fixedEntry.eduhousenVerkkokoulutus": "Verkkokoulutuspalvelu",
  "cms.fixedEntry.vapaaAjanTapaturmavakuutus": "Tapaturmavakuutus",
  "cms.fixedEntry.jasenedut": "Edut ja alennukset",
  "cms.fixedEntry.lakiruutu": "Lakiruutu-videot",
  "cms.fixedEntries.title": "Kiinteät sivupohjat",
  "cms.fixedEntries.empty": "Ei sisältöä valitulla kielellä.",
  "cms.fixedEntries.loading": "Ladataan kiinteitä sivupohjia…",
  "cms.fixedEntries.error": "Kiinteiden sivupohjien lataus epäonnistui.",
  "cms.fixedEntries.discardStagedEdit": "Poista luonnos",
  "cms.fixedEntries.discardInitial.confirm.title": "Poistetaanko kirjoittamasi sisältö?",
  "cms.fixedEntries.discardInitial.confirm.body": "Kirjoittamasi sisältö poistetaan pysyvästi. Kiinteä sivu säilyy ja sen voi kirjoittaa uudelleen.",
  "cms.fixedEntries.discardInitial.confirm.confirm": "Poista kirjoittamasi sisältö",
  "cms.fixedEntries.copyFromFiToLocale.sv": "Kopioi suomenkielinen sisältö ruotsin luonnokseksi",
  "cms.fixedEntries.copyFromFiToLocale.en": "Kopioi suomenkielinen sisältö englannin luonnokseksi",
  "cms.fixedEntries.copySourceChecking": "Tarkistetaan suomenkielistä lähdesisältöä…",
  "cms.fixedEntries.copySourceUnavailable": "Suomenkielistä lähdettä ei ole saatavilla. Valitun kielen luonnosta ei voi kopioida.",
  "cms.fixedEntries.copyFailed": "Suomenkielisen sisällön kopiointi valitun kielen luonnokseksi epäonnistui.",
  "cms.tabs.julkaistut": "Julkaistut",
  "cms.tabs.luonnokset": "Luonnokset",
  "cms.tabs.sivupohjat": "Tallennetut sivupohjat",
  "cms.templates.cancel": "Peruuta",
  "cms.templates.create": "Tallenna pohja",
  "cms.templates.heading": "Tallennetut sivupohjat",
  "cms.templates.delete": "Poista sivupohja",
  "cms.templates.delete.confirm": "Haluatko poistaa sivupohjan",
  "cms.templates.delete.confirmAction": "Poista",
  "cms.templates.delete.description": "Sivupohja poistetaan pysyvästi Sivupohjat-näkymästä. Alkuperäinen sivu ja tästä sivupohjasta luodut sivut säilyvät ennallaan.",
  "cms.templates.delete.error": "Sivupohjan poisto epäonnistui.",
  "cms.templates.delete.title": "Poista sivupohja",
  "cms.templates.empty": "Tallenna sivupohja olemassa olevasta julkaistusta tai luonnossivusta.",
  "cms.templates.error": "Sivupohjien lataus epäonnistui.",
  "cms.templates.loadMore": "Näytä lisää sivupohjia",
  "cms.templates.loading": "Ladataan sivupohjia…",
  "cms.templates.locale.en": "englanti",
  "cms.templates.locale.fi": "suomi",
  "cms.templates.locale.sv": "ruotsi",
  "cms.templates.type.contentPage": "Sisältösivu",
  "cms.templates.name": "Sivupohjan nimi",
  "cms.templates.editor.preview": "Esikatselu",
  "cms.templates.editor.previewDescription": "Muokkaamasi sivupohjan esikatselu.",
  "cms.templates.error.notFound": "Sivupohjaa ei enää löydy. Päivitä lista.",
  "cms.templates.error.stale": "Sivupohjaa muokattiin toisessa istunnossa. Päivitä lista ennen uutta yritystä.",
  "cms.templates.editor.error.unknown": "Tallennuksen lopputulos ei ole tiedossa. Sivupohjaa ei tallenneta uudelleen automaattisesti.",
  "cms.templates.editor.back": "Takaisin sivupohjiin",
  "cms.templates.editor.helper": "Muokkaa sivupohjan sisältöä. Muutokset eivät muuta sivuja.",
  "cms.templates.editor.open": "Muokkaa sivupohjaa",
  "cms.templates.editor.readOnly": "Sinulla ei ole oikeutta muokata tätä sivupohjaa.",
  "cms.templates.editor.reload": "Lataa uusin versio",
  "cms.templates.editor.save": "Tallenna",
  "cms.templates.editor.saving": "Tallennetaan…",
  "cms.templates.editor.title": "Muokkaa sivupohjaa",
  "cms.templates.rename": "Nimeä uudelleen",
  "cms.templates.rename.error": "Sivupohjan uudelleennimeäminen epäonnistui.",
  "cms.templates.rename.required": "Anna sivupohjalle nimi.",
  "cms.templates.rename.save": "Tallenna nimi",
  "cms.templates.rename.description": "Anna sivupohjalle uusi nimi.",
  "cms.templates.rename.title": "Nimeä sivupohja uudelleen",
  "cms.templates.retry": "Yritä uudelleen",
  "cms.templates.source.description": "Valitse julkaistu tai luonnossivu, jonka sisältö tallennetaan sivupohjaksi.",
  "cms.templates.source.close": "Sulje",
  "cms.templates.source.empty": "Ei valittavia sisältösivuja.",
  "cms.templates.source.error": "Sisältösivujen lataus epäonnistui.",
  "cms.templates.source.error.changed": "Valittu sivu muuttui. Valitse se uudelleen.",
  "cms.templates.source.error.inspect": "Sivun tarkistaminen epäonnistui.",
  "cms.templates.source.error.inspectCandidates": "Sivupohjien tarkistus epäonnistui.",
  "cms.templates.source.error.nameExists": "Samanniminen sivupohja on jo tässä kielessä.",
  "cms.templates.source.error.unavailable": "Valittua sivua ei enää voi käyttää. Valitse toinen sivu.",
  "cms.templates.source.inspecting": "Tarkistetaan valittua sivua…",
  "cms.templates.source.loading": "Ladataan sisältösivuja…",
  "cms.templates.source.kind.draft": "Luonnos",
  "cms.templates.source.kind.published": "Julkaistu",
  "cms.templates.source.candidateFound": "Löytyi samanniminen sivupohja:",
  "cms.templates.source.candidateUncertain": "Tämä ei vahvista, että juuri tämä tallennus onnistui.",
  "cms.templates.source.inspectCandidates": "Tarkista sivupohjat",
  "cms.templates.source.helper": "Pohja luodaan valitun sivun sisällöstä (julkaistu tai luonnos).",
  "cms.templates.source.nameLabel": "Nimi",
  "cms.templates.source.namePlaceholder": "Pohjan nimi",
  "cms.templates.source.newCreate": "Aloita uusi tallennus",
  "cms.templates.source.noCandidate": "Samannimistä sivupohjaa ei löytynyt. Tämä ei vahvista tallennuksen peruuntumista.",
  "cms.templates.source.pageLabel": "Valitse sisältösivu",
  "cms.templates.source.pagePlaceholder": "Valitse sivu…",
  "cms.templates.source.reinspect": "Tarkista valittu sivu uudelleen",
  "cms.templates.source.save": "Tallenna",
  "cms.templates.source.title": "Uusi pohja",
  "cms.templates.source.unknown": "Tallennuksen lopputulos ei ole tiedossa."
}
